import logo from '../../images/logo.svg'
import './Footer.css'

function Footer() {
  return (
    <div className="footer">
      <div className="footer__up">  
        <img src={logo} className="footer__logo"></img>
        <ul className="footer__up-contacts">
            <li className="footer__up-contact">+7 495 14 495 16</li>
            <li className="footer__up-contact">101000, Россия, г. Москва, вн.тер.г. Муниципальный округ басманный, ул. Мясницкая, д. 24/7, стр. 1, помещ. 1/12а</li>
            <li className="footer__up-contact">info@veleres.ru</li>
            <li className="footer__up-contact">
              <a className="footer__up-contact-link" href='https://veleres.ru/' target='blank'>https://veleres.ru/</a>
            </li>
        </ul>
      </div>

      <div className="footer__down">
        <p className="footer__down-copyright">Copyright Veles Reserch 2021</p>
        <ul className="footer__up-icons-container">
          <li className="footer__up-icon footer__up-icon-vk"></li>
          <li className="footer__up-icon footer__up-icon-telegram"></li>
          <li className="footer__up-icon footer__up-icon-utube"></li>
        </ul>
      </div>  
    </div>
  );
}

export default Footer;